export function JustifyStartIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.95829 1.66634C3.95829 1.2061 3.5852 0.833008 3.12496 0.833008C2.66472 0.833008 2.29163 1.2061 2.29163 1.66634V18.333C2.29163 18.7932 2.66472 19.1663 3.12496 19.1663C3.5852 19.1663 3.95829 18.7932 3.95829 18.333V1.66634ZM7.29163 4.99967H17.2916V7.49967H7.29163V4.99967ZM7.29163 12.4997H14.7916V14.9997H7.29163V12.4997ZM5.62496 4.99967C5.62496 4.0792 6.37115 3.33301 7.29163 3.33301H17.2916C18.2121 3.33301 18.9583 4.0792 18.9583 4.99967V7.49967C18.9583 8.42015 18.2121 9.16634 17.2916 9.16634H7.29163C6.37115 9.16634 5.62496 8.42015 5.62496 7.49967V4.99967ZM5.62496 12.4997C5.62496 11.5792 6.37115 10.833 7.29163 10.833H14.7916C15.7121 10.833 16.4583 11.5792 16.4583 12.4997V14.9997C16.4583 15.9201 15.7121 16.6663 14.7916 16.6663H7.29163C6.37115 16.6663 5.62496 15.9201 5.62496 14.9997V12.4997Z"
        fill="currentColor"
      />
    </svg>
  );
}
